export const surveyDetailsConfig = {
	routes: {
		surveyBuilder: {
			label: "Build",
			tab: "build",
		},
		previewSurvey: {
			label: "Preview",
			tab: "preview",
		},
		surveyParticipants: {
			label: "Participants",
			tab: "participants",
		},
		surveyAnalytics: {
			label: "Results",
			tab: "results",
		},
	},
	routesOriginalLabels: {
		surveyBuilder: {
			label: "Build Survey",
			tab: "build",
		},
		previewSurvey: {
			label: "Preview Survey",
			tab: "preview",
		},
		surveyAnalytics: {
			label: "Survey Results",
			tab: "results",
		},
	},
	defaultQuestion: {
		type: "text",
		order: 1,
	},
};
